import React from 'react'
import deepl_pro_logo from '../../../images/logo_DeepL_Pro.svg'

export default function DeeplLogo() {
  return (
    <img src={deepl_pro_logo} alt="Logo DeepL Pro" style={{ maxWidth: 160 }}/>
  )
}
